// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AgentIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AgentIcon" ref={forwardedRef} {...props}>
      <path d="M7.287 9.646a1.5 1.5 0 1 1-.001 3 1.5 1.5 0 0 1 .001-3" />
      <path d="M12.713 9.646a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
      <path d="M8 4.5h4V2h1.75v2.5h2.691l.109.006a1.06 1.06 0 0 1 .95 1.053v3.734h.441A1.06 1.06 0 0 1 19 10.352v1.632a1.06 1.06 0 0 1-1.059 1.059H17.5v3.398l-.006.109a1.06 1.06 0 0 1-.944.944L16.44 17.5H3.56a1.06 1.06 0 0 1-1.053-.95L2.5 16.44v-3.398H2.059A1.06 1.06 0 0 1 1 11.984v-1.632a1.06 1.06 0 0 1 1.059-1.059H2.5V5.559A1.06 1.06 0 0 1 3.559 4.5H6.25V2H8zM4.088 15.912h11.824V6.088H4.088z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AgentIcon = /* @__PURE__ */ Object.assign(AgentIconComponent, {
  displayName: 'AgentIcon',
});
